import c from "moment";
import a from "../time/toMinutes.mjs";
import f from "../time/getNextTenthMinute.mjs";
import o from "../time/getTimeSpanParts.mjs";
function T(u, i, d = "00:00:00") {
  const s = o(i.from), m = o(i.duration), r = o(d), t = u.clone().hour(s.hours).minute(s.minutes).second(0).millisecond(0), n = a(r.hours, r.minutes), e = t.clone().add(m.hours, "hours").add(m.minutes, "minutes");
  return e.diff(c(), "minutes") < n && e.subtract(n, "minutes"), t.add(n, "minutes"), t.minute(f(t)), [t, e];
}
export {
  T as default
};
